import React from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LEGAL_PAGES } from "../lib/legalContent";
import { ArrowLeft, Lightning, ShieldWarning } from "@phosphor-icons/react";

const SLUG_TO_KEY = {
  termini: "terms", agb: "terms", conditions: "terms",
  privacy: "privacy", datenschutz: "privacy", confidentialite: "privacy",
  impressum: "impressum", "mentions-legales": "impressum",
  cookie: "cookies", cookies: "cookies",
};

export default function LegalPage() {
  const { slug } = useParams();
  const { t, i18n } = useTranslation();
  const lang = i18n.resolvedLanguage === "de" ? "de" : i18n.resolvedLanguage === "fr" ? "fr" : "it";

  const key = SLUG_TO_KEY[slug];
  if (!key) return <Navigate to="/" replace />;

  const page = LEGAL_PAGES[lang][key];

  return (
    <div className="min-h-screen" data-testid={`legal-page-${key}`}>
      <div className="max-w-3xl mx-auto px-6 lg:px-10 py-12">
        <Link to="/" className="text-xs uppercase tracking-widest text-zinc-400 hover:text-white flex items-center gap-2 mb-8" data-testid="legal-back-link">
          <ArrowLeft size={14} /> {t("common.back")}
        </Link>

        <div className="flex items-center gap-2 mb-2">
          <Lightning size={18} weight="fill" className="text-[#E30613]" />
          <span className="text-[10px] uppercase tracking-[0.3em] text-[#E30613] font-bold">FitAgenda CH</span>
        </div>
        <h1 className="font-display text-4xl sm:text-5xl uppercase font-black text-white tracking-tight">{page.title}</h1>
        <div className="text-xs text-zinc-500 mt-3 uppercase tracking-widest">{page.updated}</div>

        {/* Disclaimer banner for beta */}
        <div className="mt-8 border border-[#FFB800]/40 bg-[#FFB800]/5 p-4 flex items-start gap-3" data-testid="legal-beta-disclaimer">
          <ShieldWarning size={20} className="text-[#FFB800] shrink-0 mt-0.5" weight="fill" />
          <div className="text-xs text-zinc-300 leading-relaxed">
            <strong className="text-[#FFB800]">{t("legal.beta_notice_title")}</strong> — {t("legal.beta_notice_body")}
          </div>
        </div>

        <div className="mt-10 space-y-8" data-testid="legal-content">
          {page.sections.map((s) => (
            <section key={s.h}>
              <h2 className="font-display text-xl uppercase font-black text-white tracking-tight">{s.h}</h2>
              <p className="mt-3 text-sm text-zinc-300 leading-relaxed whitespace-pre-line">{s.p}</p>
            </section>
          ))}
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 text-xs text-zinc-500">
          <div>{t("legal.questions_title")}</div>
          <div className="mt-2 space-x-4 text-zinc-300">
            <a href="mailto:privacy@fitagenda.ch" className="hover:text-[#E30613]">privacy@fitagenda.ch</a>
            <a href="mailto:info@fitagenda.ch" className="hover:text-[#E30613]">info@fitagenda.ch</a>
          </div>
        </div>
      </div>
    </div>
  );
}
